document.addEventListener("DOMContentLoaded", () => {
	const heroBannerCarousels = document.querySelectorAll(".hero-banner-carousel__background-swiper");

	if (heroBannerCarousels) {
		heroBannerCarousels.forEach((carousel) => {
			const autoPlay = carousel.getAttribute('data-autoplay') === 'true';
			const autoplayDelay = carousel.getAttribute('data-autoplay-delay') || 3000;

			const swiperBackground = new Swiper(carousel, {
				// Optional parameters
				spaceBetween: 30,
				effect: "fade",
				keyboard: true,
				allowTouchMove: false,
				slidesPerView: 1,
			});

			const swiperContent = new Swiper(carousel.parentElement.querySelector(".hero-banner-carousel__content-swiper"), {
				// Optional parameters
				spaceBetween: 30,
				effect: "fade",
				keyboard: true,
				allowTouchMove: false,
				slidesPerView: 1,
				// autoHeight: true,
				...(autoPlay && {
					autoplay: {
						delay: autoplayDelay,
						disableOnInteraction: false,
						pauseOnMouseEnter: true,
					},
				}),

				// Navigation arrows
				navigation: {
					nextEl: carousel.parentElement.querySelector(".hero-banner__swiper.swiper-button-next"),
					prevEl: carousel.parentElement.querySelector(".hero-banner__swiper.swiper-button-prev"),
				},
			});

			// synchronize the sliders
			// swiperBackground.controller.control = swiperContent;
			swiperContent.controller.control = swiperBackground;
		});
	}
});
